<template>
	<v-container class="navbar" pa-0>
		<v-container py-3 ma-0 class="hidden-sm-and-down" id="spacer" />
		<!-- hidden nav drawer -->
		<v-navigation-drawer
			width=350
			temporary
			v-model="drawer"
			fixed
		  
		>
			<v-list>
				<v-list-tile
				>
					<v-btn
						@click.stop="drawer = !drawer"
						flat
						small
						absolute
						right
						fab
					>
					X
					</v-btn>
				</v-list-tile>
				<template
					v-for="item in items"
				>
					<v-list-tile 
						active-class=""
						exact
						v-bind:to="item.data[0].path" 
						v-bind:href="item.data[0].href" 
						v-if="!item.group"
						class="navbar-list-tile drawer-single-line"
					>
						<v-list-tile-title>{{item.data[0].title}}</v-list-tile-title>
					</v-list-tile>
					
					<v-list-group
						v-if="item.group"
					>
						<v-list-tile
							slot="activator"
						>
							<v-list-tile-content>
								<v-list-tile-title>{{item.group}}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
						<v-list-tile
							v-for="(d,j) in item.data""
							:key="j"
							v-bind:to="d.path"
							v-bind:href="d.href"
							exact
							active-class=""
							class="navbar-list-tile"
						>
							<v-icon/>
							<v-icon size=10 style="height:auto;">fiber_manual_record</v-icon>
							<v-list-tile-title>
								{{ d.title }}
							</v-list-tile-title>
						</v-list-tile>
					</v-list-group>
				
				</template> 
			</v-list>
		  
		</v-navigation-drawer>
	
		<!--navbar-->
		<v-toolbar dense flat color="transparent" >
			<v-toolbar-side-icon
				@click.stop="drawer = !drawer"
				class="hidden-md-and-up"
			/>
			<v-toolbar-items class="hidden-sm-and-down">
				<template v-for="(item,i) in items">
					<v-btn
						exact
						flat
						active-class=""	
						v-bind:to="item.data[0].path"	
						v-bind:href="item.data[0].href"	
						v-if="!item.group"
					>
						{{item.data[0].title}}
					</v-btn>
					<v-menu 
						open-on-hover
						bottom
						offset-y
						min-width=400
						flat
						v-if="item.group"
					>
						<v-btn flat slot="activator">{{item.group}}</v-btn>
						<v-list dense>
							<v-list-tile
								exact
								class="navbar-list-tile"
								active-class=""
								v-for="(d,j) in item.data"
								v-bind:to="d.path"
								v-bind:href="d.href"
								:key="i*10+j"
							>
								<v-list-tile-title>{{ d.title }}</v-list-tile-title>
							</v-list-tile>
						</v-list>
					</v-menu>
				</template>
			</v-toolbar-items>
		</v-toolbar>
	</v-container>
</template>

<script>
export default {
  name: 'navigation',
  data () {
    return {
		drawer:null,
		items: [
			 {group:'', data:[{path:'/', title:'Home', href:''}]},
			 {group:'About Us', data:[
										{path:'/contactinfo', title:'Contact Info', href:''},
										{path:'/leadership', title:'Director staff', href:''}
										]},
			 {group:'', data:[{path:'/leadership', title:'Leadership', href:''},]},
			 {group:'Research', data:[
										{path:'/cryoem', title:'Cryo-EM', href:''},
										]},
			 {group:'', data:[{path:'/publications', title:'Publications', href:''},]},
			 {group:'', data:[{path:'/news', title:'News & Views', href:''},]},
			 {group:'', data:[{path:'', title:'Restricted Area', href:'http://google.com'},]},
			]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon{
	height:25px;
	display:inline-block;
	margin: 5px 5px 5px 5px;
}
.head-wrap{
	background-color:rgb(191, 87, 0);
}
.list__tile__title{
	font-family: "open_sans", sans-serif;
	font-size: 15px;
	font-weight: 400;
	text-decoration-style: solid;
	text-transform:none;
}
.btn{
	border-radius:0;
	font-family: "open_sans", sans-serif;
	font-size: 17.5px;
	font-weight: 400;
	text-decoration-style: solid;
	text-transform:none;
}
.btn:hover{
	background-color:#a04400 !important;
	color: white;
}
.drawer-single-line:hover{
	color:white;
}
.navbar{
	border-bottom: 1px solid #e1ddd2;
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue